import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button } from 'react-bootstrap';
import { getYearOptions } from '../../../services/dateServices';
import Api from '../../../../../Global/Modules/Api'
import { Link } from 'react-router-dom';

const FETCH_URL = "api/educations/unknowntrainingadmin"

class OnbekendeOpleiding extends Component {

    constructor() {
        super()
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.state = {
            data: {
                institution: '',
                name: '',
                level: '',
                country: '',
                city: '',
                yearEnd: ''
            },
            errors: {}
        }
    }

    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()
        Object.keys(this.state.data).forEach(e => {
            formData.append(e, this.state.data[e])
        })
        formData.append('MemberId', this.props.id)
        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
            .then(response => {
                if (response !== undefined)
                    Api.print(response)

                else {
                    alert('Education saved')
                    window.location.href = '/admin/leden/lid/kennis/' + this.props.id
                }
            })

    }

    render() {
        let errors = this.state.errors
        let data = this.state.data
        return (
            <Form horizontal onSubmit={this.handleSubmit}>
                <FormGroup controlId="OnbekendeOpleidingNaamInstelling">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam instelling
                    </Col>
                    <Col sm={6}>
                        <FormControl name="institution" type="text" value={data.institution} onChange={this.handleChange} required />
                        {Api.showError(errors, "institution")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOpleidingNaamOpleiding">
                    <Col componentClass={ControlLabel} sm={4}>
                        Naam opleiding
                    </Col>
                    <Col sm={6}>
                        <FormControl name="name" type="text" value={data.name} onChange={this.handleChange} required />
                        {Api.showError(errors, "name")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOpleidingNiveau">
                    <Col componentClass={ControlLabel} sm={4}>
                        Niveau
                    </Col>
                    <Col sm={6}>
                        <FormControl name="level" type="text" value={data.level} onChange={this.handleChange} required />
                        {Api.showError(errors, "level")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOpleidingLand">
                    <Col componentClass={ControlLabel} sm={4}>
                        Land
                    </Col>
                    <Col sm={6}>
                        <FormControl name="country" type="text" value={data.country} onChange={this.handleChange} required />
                        {Api.showError(errors, "country")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOpleidingPlaats">
                    <Col componentClass={ControlLabel} sm={4}>
                        Plaats
                    </Col>
                    <Col sm={6}>
                        <FormControl name="city" type="text" value={data.city} onChange={this.handleChange} required />
                        {Api.showError(errors, "city")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOpleidingAfgerond">
                    <Col componentClass={ControlLabel} sm={4}>
                        Afgerond in
                    </Col>

                    <Col sm={6}>
                        <FormControl name="yearEnd" componentClass="select" value={data.yearEnd} onChange={this.handleChange} required>
                            <option value="">selecteer</option>
                            {getYearOptions()}
                        </FormControl>
                        {Api.showError(errors, "yearEnd")}
                    </Col>
                </FormGroup>

                <FormGroup controlId="OnbekendeOpleidingDiploma">
                    <Col componentClass={ControlLabel} sm={4}>
                        Diploma (verplicht)
                    </Col>
                    <Col sm={6}>
                        <FormControl type="File" inputRef={input => this.fileInput = input} required />
                        {Api.showError(errors, "file")}
                    </Col>
                </FormGroup>

                <FormGroup>
                    <Col sm={2}>
                        <Link to={'/admin/leden/lid/kennis/' + this.props.id} className="btn btn-default">Terug</Link>
                    </Col>
                    <Col smOffset={8} sm={2}>
                        <Button type="submit">Voeg Toe</Button>
                    </Col>
                </FormGroup>
            </Form>
        );
    }
}

export default OnbekendeOpleiding;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Toevoegen/OnbekendeOpleiding.js